export default "__VITE_ASSET__CdiZKGWT__"